import { generatePath } from "react-router";
import { useQueryClient } from "react-query";
import { simpleRequest } from "core/services/api";
import { UserTestCard } from "modules/user/cards/schemas/userTestCardsApiSchemas";
import { methodSchema } from "core/schemas/http";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";
import { useMutationWithErrorHandling } from "modules/shared/hooks/useMutationWithErrorHandling";
import useFeedbackStore from "modules/feedback/hooks/useFeedbackStore";
import {
  feedbackSchema,
  actionsSchema,
} from "core/components/ActionFeedback/schemas/actionSchemas";
import { CreateCardFormValues } from "../schemas/formSchemas";
import { useContext } from "react";
import { UserIdContext } from "modules/shared/context/UserIdContext";
import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";
import { createTestCardApiSchema } from "modules/user/cards/schemas/userTestCardsApiSchemas";

export const createTestCard = (card: UserTestCard, userId?: string) =>
  userId
    ? simpleRequest(
        generatePath(ENDPOINTS.USER_TEST_CARDS, { id: userId }),
        createTestCardApiSchema,
        methodSchema.enum.post,
        card
      )
    : Promise.reject();

export const useCreateTestCard = () => {
  const { data } = useSelfcare(false);
  const contextUserId = useContext(UserIdContext);
  const userId = contextUserId ?? data?.id.toString();
  const queryClient = useQueryClient();
  const { setFeedback } = useFeedbackStore();
  return useMutationWithErrorHandling(
    (data: CreateCardFormValues) => createTestCard(data, userId),
    {
      onSuccess: () => {
        contextUserId
          ? queryClient.invalidateQueries(["userTestCards", Number(userId)])
          : queryClient.invalidateQueries(["selfcare"]);

        setFeedback(feedbackSchema.enum.success, actionsSchema.enum.createCard);
      },
    }
  );
};
